<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Pathology Diagnosis Code</p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>
            <section class="modal-card-body">
                <!--                  content-->


                <b-tabs v-model="activeTab">
                    <b-tab-item label="Select By Hierarchy">
                        <div>
                            <b-field label="Chapter"  >
                                <v-select :options="level1" label="name" v-model="level1Selected"  ></v-select>
                            </b-field>

                            <b-field label="Body System"  >
                                <v-select :options="level2" label="name" v-model="level2Selected"   ></v-select>
                            </b-field>

                            <b-field label="Organ/Tissue"  >
                                <v-select :options="level3" label="name" v-model="level3Selected"  ></v-select>
                            </b-field>

                            <b-field label="Character/Subcategories"  >
                                <v-select :options="level4" label="name" v-model="level4Selected"   ></v-select>
                            </b-field>

                            <b-field label="Extensions"  >
                                <v-select :options="level5" label="name" v-model="level5Selected"  ></v-select>
                            </b-field>

                            <b-field label="Unclassified Descriptions"
                                     :type="{ 'is-danger': hasErrorUnClassifiedCodes }"
                                     :message="{ 'Error over max length ': hasErrorUnClassifiedCodes}">
                                <template slot="label">
                                    Unclassified Descriptions <span class="has-text-primary is-italic" v-if="unClassifiedCodes!==null">({{unClassifiedCodes.length}}/255)</span>
                                </template>
                                <b-input v-model="unClassifiedCodes"></b-input>
                            </b-field>



                            <b-field label="%"  >
                                <v-select :options="diseasecodeAccurate" label="name" v-model="diseasecodeAccurateSelected"  ></v-select>
                            </b-field>



                            <b-field label="Remark"
                                     :type="{ 'is-danger': hasErrorRemark }"
                                     :message="{ 'Error over max length ': hasErrorRemark}">
                                <template slot="label">
                                    Remark <span class="has-text-primary is-italic" v-if="commentTxt!==null">({{commentTxt.length}}/255)</span>
                                </template>
                                <b-input v-model="commentTxt"></b-input>
                            </b-field>


                            <b-field label="">
                                &nbsp;
                            </b-field>
                            <b-field label="">
                                &nbsp;
                            </b-field>
                            <b-field label="">
                                &nbsp;
                            </b-field>
                        </div>
                    </b-tab-item>

                    <b-tab-item label="Search by Keyword"  icon="magnify" >
<!--                   header serach bar      /-->
                        <form @keyup.enter="keyEnterPress">
                            <b-field grouped    >

                                <b-field label="NAME"
                                         :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                         :message="{ 'please some input to search': hasErrorAllFieldBlank }"
                                >
                                    <b-input   v-model="nameSearch" placeholder="» » » » Neoplasia « « « «"

                                    ></b-input>

                                </b-field>


                                <b-field label="CODE"
                                         :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                         :message="{ 'please some input to search': hasErrorAllFieldBlank }"  >
                                    <b-input v-model="codeSearch"  placeholder="» » » » » » A01 « « « « « «"
                                    ></b-input>
                                </b-field>



                                <b-field label="Search">
                                    <b-button type="is-success" icon-left="magnify"  outlined @click="searchDiseaseCode" :disabled="isFullScreenSearching"  ref="btnSearch"  ></b-button>
                                </b-field>


                                <b-field label="Clear All">
                                    <b-button type="is-success" icon-left="close"  outlined @click="initDat"   ref="btnClearAll"  ></b-button>
                                </b-field>

                            </b-field>
                        </form>
<!--                   result search      -->
                        <b-table
                                :data="isEmpty ? [] : resultSearch"
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards>


                                <b-table-column   label="NAME" v-slot="props">
                                    {{ props.row.name }}
                                </b-table-column>
                                <b-table-column   label="CODE" v-slot="props">
                                    {{ props.row.code }}
                                </b-table-column>

                                <b-table-column   label="#"  v-slot="props">
                                    <b-button type="is-info" icon-right="check" @click="selectCode(props.row.id)" />
                                </b-table-column>



                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                            </template>
                        </b-table>

                    </b-tab-item>


                </b-tabs>


                <b-loading  :active.sync="isFullScreenSearching" ></b-loading>

            </section>
            <footer class="modal-card-foot">
<!--                <button class="button"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger" @click="closeBtn">Cancel</b-button>
                <b-button type="is-success" @click="save">Save</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios"
    import { getBaseURLforBackEnd , getConfigAxios ,genUUID}  from '@/utils.js'
    import 'vue-select/dist/vue-select.css';


    export default {
        name: "SelectDiseaseCode" ,

        mounted() {
            // init data
            this.fetchLevel(1,null)
            this.fetchDiseasecodeAccurate()
            // init input
            this.initDat()
            //
            this.level1Selected = null
            this.level1Selected = null
            this.level1Selected = null
            this.level1Selected = null
            this.level1Selected = null
            this.diseasecodeAccurateSelected = null
            this.unClassifiedCodes = null
            this.commentTxt = null
            this.fetchAuto = true
        },
        watch:{
            commentTxt:{
                handler: function (val) {
                    (val.length>this.MAX_LENGTH_Remark && val !== null) ?  this.hasErrorRemark = true :  this.hasErrorRemark = false
                }
            },
            unClassifiedCodes :{
                handler: function (val) {
                    (val.length>this.MAX_LENGTH_UNCLASSIFIEDCODES && val !== null) ?  this.hasErrorUnClassifiedCodes = true :  this.hasErrorUnClassifiedCodes = false
                }
            },
            level1Selected: {
                handler: function (val) {
                    if(val && this.fetchAuto) {
                        this.isFullScreenSearching = true
                        this.level2 = []
                        this.level2Selected = null
                        this.level3Selected = null
                        this.level4Selected = null
                        this.level5Selected = null
                        this.fetchLevel(2,this.level1Selected.id)
                        this.isFullScreenSearching = false
                    } else{
                        this.level2 = []
                        this.level2Selected = null
                        this.level3Selected = null
                        this.level4Selected = null
                        this.level5Selected = null
                    }
                }
            } ,

            level2Selected: {
                handler: function (val) {
                    if(val && this.fetchAuto) {
                        // console.log('call level3  with : '+this.level2Selected.id ,'  and parent : '+this.level2Selected.idparent )
                        this.isFullScreenSearching = true
                        this.level3 = []
                        this.level3Selected = null
                        this.level4Selected = null
                        this.level5Selected = null
                        this.fetchLevel(3,this.level2Selected.id)
                        this.isFullScreenSearching = false
                    } else{
                        this.level3 = []
                        this.level3Selected = null
                        this.level4Selected = null
                        this.level5Selected = null
                    }
                }
            } ,

            level3Selected: {
                handler: function (val) {
                    if(val && this.fetchAuto) {
                        // console.log('call level3  with : '+this.level2Selected.id ,'  and parent : '+this.level2Selected.idparent )
                        this.isFullScreenSearching = true
                        this.level4 = []
                        this.level4Selected = null
                        this.level5Selected = null
                        this.fetchLevel(4,this.level3Selected.id)
                        this.isFullScreenSearching = false
                    } else{
                        this.level4 = []
                        this.level4Selected = null
                        this.level5Selected = null
                    }
                }
            }
            ,
            level4Selected: {
                handler: function (val) {
                    if(val && this.fetchAuto) {
                        // console.log('call level3  with : '+this.level2Selected.id ,'  and parent : '+this.level2Selected.idparent )
                        this.isFullScreenSearching = true
                        this.level5 = []
                        this.level5Selected = null
                        this.fetchLevel(5,this.level4Selected.id)
                        this.isFullScreenSearching = false
                    } else{
                        this.level5 = []
                        this.level5Selected = null
                    }
                }
            }

        },
        data(){
          return {
              dataPrePareToAdd:
                  { 'ID': '' ,'level1ID': null, 'level1Name': '','level2ID': null, 'level2Name': '','level3ID': null, 'level3Name': '', 'level4ID': null, 'level4Name': '', 'level5ID': null, 'level5Name': '','labDiseasecodeAccurateID': null, 'labDiseasecodeAccurateName': null, 'unClassifiedCodes' : null , 'comment' : null}
              ,
              level1 :  [] ,
              level1Selected : null,
              level2 :  [] ,
              level2Selected : null,
              level3 :  [] ,
              level3Selected : null,
              level4 :  [] ,
              level4Selected : null,
              level5 :  [] ,
              level5Selected : null,
              diseasecodeAccurate : [],
              diseasecodeAccurateSelected : null,
              unClassifiedCodes : null,
              commentTxt : null,
              isFullScreenSearching : false,
              activeTab : 0 ,
              nameSearch : '',
              codeSearch : '',
              hasErrorAllFieldBlank : false,
              resultSearch:[],
              isEmpty : false ,
              dataSelectEachLayer : [],
              fetchAuto : true,

              //
              MAX_LENGTH_UNCLASSIFIEDCODES : 255,
              MAX_LENGTH_Remark : 255,
              hasErrorUnClassifiedCodes : false,
              hasErrorRemark : false
          }
        },
        methods:{
         async selectCode(id){
                  this.isFullScreenSearching = true
                  const dat = {
                    "id": id
                   }
                  const vm = this
                  await  axios.post(`${getBaseURLforBackEnd()}/api/getallrootdiseasecodefromid`,dat,getConfigAxios())
                        .then((res)=>{
                            vm.dataSelectEachLayer  = res.data
                            vm.isFullScreenSearching = false

                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                        })
                  this.activeTab = 0
                  this.fetchAuto = false
                  // console.log(this.dataSelectEachLayer)
                  // loop
                  // console.log(JSON.stringify( this.dataSelectEachLayer))
                  for(var i=0;i<this.dataSelectEachLayer.length;i++){
                      // console.log(this.dataSelectEachLayer[i])
                      if(i === 0){
                          await   this.fetchLevel(i+1,this.dataSelectEachLayer[i].idparent)
                          this.level1Selected = {
                                                   'id' : this.dataSelectEachLayer[i].id ,
                                                   'name' : this.dataSelectEachLayer[i].name ,
                                                   'code' :  this.dataSelectEachLayer[i].code ,
                                                   'idparent' : this.dataSelectEachLayer[i].idparent
                                                  }

                      }
                      if(i === 1){
                          await   this.fetchLevel(i+1,this.dataSelectEachLayer[i].idparent)
                          this.level2Selected = {
                                                  'id' : this.dataSelectEachLayer[i].id ,
                                                  'name' : this.dataSelectEachLayer[i].name ,
                                                  'code' :  this.dataSelectEachLayer[i].code ,
                                                  'idparent' : this.dataSelectEachLayer[i].idparent
                                                }
                      }
                      if(i === 2){
                          await   this.fetchLevel(i+1,this.dataSelectEachLayer[i].idparent)
                          this.level3Selected = {
                                                  'id' : this.dataSelectEachLayer[i].id ,
                                                  'name' : this.dataSelectEachLayer[i].name ,
                                                  'code' :  this.dataSelectEachLayer[i].code ,
                                                  'idparent' : this.dataSelectEachLayer[i].idparent
                                                  }
                      }
                      if(i === 3){
                          await   this.fetchLevel(i+1,this.dataSelectEachLayer[i].idparent)
                          this.level4Selected = {
                                                  'id' : this.dataSelectEachLayer[i].id ,
                                                  'name' : this.dataSelectEachLayer[i].name ,
                                                  'code' :  this.dataSelectEachLayer[i].code ,
                                                  'idparent' : this.dataSelectEachLayer[i].idparent
                                                }
                      }
                      if(i === 4){
                          await   this.fetchLevel(i+1,this.dataSelectEachLayer[i].idparent)
                          this.level5Selected = {
                                                  'id' : this.dataSelectEachLayer[i].id ,
                                                  'name' : this.dataSelectEachLayer[i].name ,
                                                  'code' :  this.dataSelectEachLayer[i].code ,
                                                  'idparent' : this.dataSelectEachLayer[i].idparent
                                                }
                      }

                  }
                 this.fetchAuto = true
            },
            keyEnterPress(){
                // e.preventDefault()
                this.searchDiseaseCode()
            },
            initDat(){
                    this.isFullScreenSearching = false
                    this.activeTab = 0
                    this.nameSearch = ''
                    this.codeSearch = ''
                    this.hasErrorAllFieldBlank = false
                    this.resultSearch=[]
                    this.isEmpty = false
            },
            searchDiseaseCode(){
                if (this.nameSearch.length === 0 && this.codeSearch.length === 0   ) {
                    this.hasErrorAllFieldBlank = true
                    return
                    // check OPD No. only
                } else{
                    // console.log("ok")
                    this.hasErrorAllFieldBlank = false
                    this.isFullScreenSearching = true
                    const dat = {
                        "name": this.nameSearch ? this.nameSearch : null ,
                        "code": this.codeSearch ? this.codeSearch : null
                    }
                    const vm = this
                    axios.post(`${getBaseURLforBackEnd()}/api/searchindiseasecode`,dat,getConfigAxios())
                        .then((res)=>{
                            vm.resultSearch  = res.data
                            vm.isFullScreenSearching = false
                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                        })




                }
            },
            fetchDiseasecodeAccurate(){
                const vm = this

                axios.post(`${getBaseURLforBackEnd()}/api/list_of_diseasecode_accurate`,getConfigAxios())
                    .then((res)=>{
                        vm.diseasecodeAccurate  = res.data
                    })
            },
            fetchLevel(level,idparent){
                const vm = this
                const datTo ={
                    "idparent": idparent,
                    "admin": false
                }
                axios.post(`${getBaseURLforBackEnd()}/api/listofdiseasecode`,datTo,getConfigAxios())
                    .then((res)=>{
                        if (level === 1){
                            vm.level1 = res.data
                        } else if(level === 2){
                            vm.level2 = res.data
                        }else if(level === 3){
                            vm.level3 = res.data
                        }else if(level === 4){
                            vm.level4 = res.data
                        }else if(level === 5){
                            vm.level5 = res.data
                        }

                    })
            },

            save(){

                 if(this.hasErrorUnClassifiedCodes){
                     this.$buefy.dialog.alert({
                         title: 'Error',
                         message: 'UnClassifiedCodes Max Length ',
                         type: 'is-danger',
                         hasIcon: true,
                         icon: 'times-circle',
                         iconPack: 'fa',
                         ariaRole: 'alertdialog',
                         ariaModal: true
                     })
                     return
                 }


                if(this.hasErrorRemark){
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Remark Max Length ',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }



                 if(this.level1Selected || this.unClassifiedCodes || this.commentTxt) {
                     this.dataPrePareToAdd = {
                         // condition ? exprIfTrue : exprIfFalse
                         'ID': genUUID(10),
                         'level1ID': this.level1Selected ? this.level1Selected.id : '',
                         'level1Name': this.level1Selected ? this.level1Selected.name : '',
                         'level2ID': this.level2Selected ? this.level2Selected.id : '',
                         'level2Name': this.level2Selected ? this.level2Selected.name : '',
                         'level3ID': this.level3Selected ? this.level3Selected.id : '',
                         'level3Name': this.level3Selected ? this.level3Selected.name : '',
                         'level4ID': this.level4Selected ? this.level4Selected.id : '',
                         'level4Name': this.level4Selected ? this.level4Selected.name : '',
                         'level5ID': this.level5Selected ? this.level5Selected.id : '',
                         'level5Name': this.level5Selected ? this.level5Selected.name : '',
                         'labDiseasecodeAccurateID': this.diseasecodeAccurateSelected ? this.diseasecodeAccurateSelected.id : null,
                         'labDiseasecodeAccurateName': this.diseasecodeAccurateSelected ? this.diseasecodeAccurateSelected.name : null,
                         'comment': this.commentTxt,
                         'unClassifiedCodes': this.unClassifiedCodes
                     }
                     this.$emit('closeWithChange', this.dataPrePareToAdd)
                     this.$emit('close')

                 }else{
                     this.$buefy.dialog.alert({
                         title: 'Error',
                         message: 'Please Select Topic in Chapter Field !!!  ',
                         type: 'is-danger',
                         hasIcon: true,
                         icon: 'times-circle',
                         iconPack: 'fa',
                         ariaRole: 'alertdialog',
                         ariaModal: true
                     })

                 }






            },
            closeBtn(){
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>

</style>